export const isValidSelector = (selector: string) => {
  try {
    document.querySelectorAll(selector)
    return true
  } catch {
    return false
  }
}
